import { cn } from "@/lib/utils";

interface ITrialCopyProps {
  variant?: "banner" | "inline";
  className?: string;
  /** Onboarding context: "Your 14-day trial has started. Add a card…" */
  onboarding?: boolean;
}

/**
 * Shared trial copy: "14-day free trial on all plans" or onboarding variant.
 */
export function TrialCopy({
  variant = "inline",
  onboarding = false,
  className,
}: ITrialCopyProps): React.ReactElement {
  const text = onboarding
    ? "Your 14-day trial has started. Add a card now to avoid read-only mode when the trial ends, or skip and add later."
    : "14-day free trial on all plans.";

  if (variant === "banner") {
    return (
      <p
        className={cn(
          "rounded-lg border border-primary/20 bg-primary/5 px-4 py-3 text-sm text-foreground",
          className
        )}
      >
        {text}
      </p>
    );
  }

  return <p className={cn("text-sm text-muted-foreground", className)}>{text}</p>;
}
